import { Link } from 'react-router-dom';

const SERVICES = [
  {
    icon: 'fa-graduation-cap',
    title: 'Engineering Classes',
    text: 'At Somayya Academy, students get the advantage of more than two hundred years of combined experience of our faculties.',
    link: '/all-courses',
  },
  {
    icon: 'fa-user',
    title: 'Study Abroad',
    text: 'One solution for all trainings! Entrance examinations, language trainings, consultancy services, career guidance!',
    link: '/study-abroad',
  },
  {
    icon: 'fa-book',
    title: 'Lingual Services',
    text: 'Specially designed courses for professionals, to enrich skills to communicate and work with / for foreign clients and projects.',
    link: '/lingual-services',
  },
];

export default function AboutSection() {
  return (
    <section className="sa-about">
      {/* Title + sub-text centred */}
      <div className="sa-container" style={{ textAlign: 'center' }}>
        <h1 className="sa-about-title">ABOUT US</h1>
        <p className="sa-about-sub">
          Established in 1999, Somayya Academy is the most sought-after brand amongst coaching classes in Pune.
          So far more than 50,000 students have experienced the quality education at our academy, under the guidance of
          Prof. H. M. Somayya. Enriched with experience and 1000 students abroad, the academy also serves the purposes
          of study abroad and corporate lingual trainings.
        </p>
      </div>

      {/* 3 service cards — flex row, centred */}
      <div className="sa-container">
        <div className="sa-about-cards">
          {SERVICES.map(s => (
            <div key={s.title} className="sa-service-card">
              {/* Circular icon — matches .service-box-icon */}
              <div className="sa-card-icon-wrap">
                <span className="sa-card-icon-circle">
                  <i className={`fa ${s.icon}`} aria-hidden="true" />
                </span>
              </div>
              <h3><a>{s.title}</a></h3>
              <p>{s.text}</p>
              <div className="sa-service-btn-area">
                <Link to={s.link} className="sa-btn sa-btn-primary">Know More</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
